/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_Auto_CorrectionsInputs */

const en_apply_auto_corrections = /** @type {(inputs: Apply_Auto_CorrectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply Auto Corrections`)
};

const fr_apply_auto_corrections = /** @type {(inputs: Apply_Auto_CorrectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer les corrections automatiques`)
};

const de_apply_auto_corrections = /** @type {(inputs: Apply_Auto_CorrectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Korrekturen anwenden`)
};

const it_apply_auto_corrections = /** @type {(inputs: Apply_Auto_CorrectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applica correzioni automatiche`)
};

const ru_apply_auto_corrections = /** @type {(inputs: Apply_Auto_CorrectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Применить автоматическую коррекцию`)
};

const es_apply_auto_corrections = /** @type {(inputs: Apply_Auto_CorrectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar correcciones automáticas`)
};

const zh_cn2_apply_auto_corrections = /** @type {(inputs: Apply_Auto_CorrectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用自动更正`)
};

const ja_apply_auto_corrections = /** @type {(inputs: Apply_Auto_CorrectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動修正を適用する`)
};

const hi_apply_auto_corrections = /** @type {(inputs: Apply_Auto_CorrectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित सुधार लागू करें`)
};

const pt_pt2_apply_auto_corrections = /** @type {(inputs: Apply_Auto_CorrectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar correções automáticas`)
};

/**
* | output |
* | --- |
* | "Apply Auto Corrections" |
*
* @param {Apply_Auto_CorrectionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_auto_corrections = /** @type {((inputs?: Apply_Auto_CorrectionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_Auto_CorrectionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_apply_auto_corrections(inputs)
	if (locale === "de") return de_apply_auto_corrections(inputs)
	if (locale === "it") return it_apply_auto_corrections(inputs)
	if (locale === "ru") return ru_apply_auto_corrections(inputs)
	if (locale === "es") return es_apply_auto_corrections(inputs)
	if (locale === "zh-CN") return zh_cn2_apply_auto_corrections(inputs)
	if (locale === "ja") return ja_apply_auto_corrections(inputs)
	if (locale === "hi") return hi_apply_auto_corrections(inputs)
	if (locale === "pt-PT") return pt_pt2_apply_auto_corrections(inputs)
	return en_apply_auto_corrections(inputs)
});